import React, { useState } from 'react'
import { isDevelopment, shouldBypassAuth, devOrganizations, getDevOrganization } from '../devAuth'
import useAuthz from '../hooks/useAuthz'

const styles = {
  bar: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: 32,
    backgroundColor: '#1a1a2e',
    color: '#e0e0e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 12px',
    fontSize: 11,
    fontFamily: 'monospace',
    zIndex: 9999,
    borderTop: '1px solid #16213e',
    gap: 12
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  },
  badge: {
    backgroundColor: '#0f3460',
    color: '#ff8fa0',
    padding: '2px 6px',
    borderRadius: 3,
    fontWeight: 700,
    fontSize: 10,
    letterSpacing: 0.5
  },
  select: {
    backgroundColor: '#16213e',
    color: '#e0e0e0',
    border: '1px solid #0f3460',
    borderRadius: 3,
    fontSize: 11,
    fontFamily: 'monospace',
    padding: '1px 4px',
    cursor: 'pointer',
    outline: 'none'
  },
  roleToggle: {
    backgroundColor: 'transparent',
    border: '1px solid #0f3460',
    borderRadius: 3,
    fontSize: 10,
    fontFamily: 'monospace',
    padding: '2px 6px',
    cursor: 'pointer',
    fontWeight: 600
  },
  logoutBtn: {
    backgroundColor: 'transparent',
    color: '#ff8fa0',
    border: '1px solid #ff8fa0',
    borderRadius: 3,
    fontSize: 10,
    fontFamily: 'monospace',
    padding: '2px 6px',
    cursor: 'pointer',
    fontWeight: 600
  },
  label: {
    color: '#8a8a9a',
    fontSize: 10
  }
}

const DevToolbar = () => {
  const [collapsed, setCollapsed] = useState(false)
  const { isAdmin } = useAuthz()

  if (!isDevelopment || !shouldBypassAuth()) return null

  const currentOrg = getDevOrganization()

  const handleOrgChange = (e) => {
    localStorage.setItem('dev_organization', e.target.value)
    window.location.reload()
  }

  const handleRoleToggle = () => {
    localStorage.setItem('dev_role', isAdmin ? 'user' : 'admin')
    window.location.reload()
  }

  const handleLogout = () => {
    localStorage.setItem('dev_bypass', 'false')
    window.location.reload()
  }

  if (collapsed) {
    return (
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          right: 12,
          zIndex: 9999,
          cursor: 'pointer'
        }}
        onClick={() => setCollapsed(false)}
      >
        <span style={{
          ...styles.badge,
          padding: '3px 8px',
          borderRadius: '3px 3px 0 0',
          fontSize: 11
        }}>
          DEV
        </span>
      </div>
    )
  }

  return (
    <div style={styles.bar}>
      <div style={styles.left}>
        <span style={styles.badge}>DEV</span>
        <span style={styles.label}>org:</span>
        <select
          style={styles.select}
          value={currentOrg}
          onChange={handleOrgChange}
          aria-label='Select organization'
        >
          {devOrganizations.map(org => (
            <option key={org} value={org}>{org}</option>
          ))}
        </select>
        <span style={styles.label}>role:</span>
        <button
          style={{
            ...styles.roleToggle,
            color: isAdmin ? '#4ecca3' : '#e0e0e0',
            borderColor: isAdmin ? '#4ecca3' : '#0f3460'
          }}
          onClick={handleRoleToggle}
        >
          {isAdmin ? 'Admin' : 'User'}
        </button>
      </div>
      <div style={styles.right}>
        <span style={{ color: '#8a8a9a' }}>dev@vetavirtual.com</span>
        <button style={styles.logoutBtn} onClick={handleLogout}>
          Logout
        </button>
        <span
          style={{ cursor: 'pointer', color: '#8a8a9a', fontSize: 13 }}
          onClick={() => setCollapsed(true)}
          title='Collapse toolbar'
        >
          _
        </span>
      </div>
    </div>
  )
}

export default DevToolbar
